import { TFactoryActions } from './factory.actions';
import { TMMFactoryActionTypes, TMMFactoryState } from './factory.models';

export const FACTORY_FEATURE_KEY = 'factory';

export const initialState: TMMFactoryState = {
  factoryId: '',
  userName: '',
};

export function factoryReducer(state = initialState, action: TFactoryActions): TMMFactoryState {
  switch (action.type) {
    case TMMFactoryActionTypes.SetFactoryId:
      return {
        ...state,
        factoryId: action.factoryId,
      };
    case TMMFactoryActionTypes.SetUserName:
      return {
        ...state,
        userName: action.userName,
      };
    default:
      return state;
  }
}
